const FILING_CABINET_COMPONENT = document.querySelector('.filing-cabinet-component');
//loader and error message - these are defined here but also used in sdap.js
let loadCirc = document.createElement('div');
loadCirc.classList = 'list-loader';
let loadMsg = document.createElement('span');
let loadWrap = document.createElement('div');
loadWrap.classList = 'loader-wrapper';
loadWrap.appendChild(loadCirc);
loadWrap.appendChild(loadMsg);


//tabs id
let resExchange = document.querySelector('[data-id="ReservationToExchange"]');
let exchangeComp = document.querySelector('[data-id="ExchangeToCompletion"]');
let optionChoice = document.querySelector('[data-id="OptionsAndChoices"]');
let movWar = document.querySelector('[data-id="MovingInAndWarranty"]');
if (FILING_CABINET_COMPONENT) {
    let getResExachange = async function() {
        let errWr = document
            .querySelector(`div.tab-item-content[data-id*="${resExchange.dataset.id}"]`)
            .querySelector('.table-wrapper');
        loadMsg.innerText = document.querySelector('.loading-message').value;
        loadMsg.classList = 'loader-title';
        FILING_CABINET_COMPONENT.appendChild(loadWrap);
        let NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
        let siteCode = document.querySelector('#scode').value;
        let plotCode = document.querySelector('#pcode').value;
        let response = await fetch(
            `${APIPrefix.get()}/api/mhp/properties/filingcabinet?type=${resExchange.dataset.id}&noOfItemsPerPage=${NUMB_PER_PAGE}&sitecode=${siteCode}&plotcode=${plotCode}`
        );
        if (response.status == 200) {
            let data = await response.json();
            if (data.status == "failure") {
                loadWrap.removeChild(loadCirc);
                loadMsg.innerText = data.message;
                loadMsg.classList = 'error-title';
                errWr.appendChild(loadMsg);
            } else if (data.status === "401") {
                APIUtils.redirectUserToSigninPage();
            } else {
                FILING_CABINET_COMPONENT.removeChild(loadWrap);
                return data;
            }
        } else {
            loadWrap.removeChild(loadCirc);
            loadMsg.innerText = document.querySelector('.error-message').value;
            loadMsg.classList = 'error-title';
            errWr.appendChild(loadMsg);
            throw new Error(`HTTP error! status: ${response.status}`); 
        }
    };

    let getExchangeComp = async function() {
        let errWr = document
            .querySelector(`div.tab-item-content[data-id*="${exchangeComp.dataset.id}"]`)
            .querySelector('.table-wrapper');
        let NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
        let siteCode = document.querySelector('#scode').value;
        let plotCode = document.querySelector('#pcode').value;
        let response = await fetch(
            `${APIPrefix.get()}/api/mhp/properties/filingcabinet?type=${exchangeComp.dataset.id}&noOfItemsPerPage=${NUMB_PER_PAGE}&sitecode=${siteCode}&plotcode=${plotCode}`
        );
        if (response.status == 200) {
            let data = await response.json();
            if (data.status == "failure") {
                loadMsg.innerText =  data.message;
                loadMsg.classList = 'error-title';
                errWr.appendChild(loadMsg);
            } else if (data.status === "401") {
                APIUtils.redirectUserToSigninPage();
            } else {
                return data;
            }
        } else {
            loadMsg.innerText = document.querySelector('.error-message').value;
            loadMsg.classList = 'error-title';
            errWr.appendChild(loadMsg);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    };

    let getOptChoice = async function() {
        let NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
        let siteCode = document.querySelector('#scode').value;
        let plotCode = document.querySelector('#pcode').value;
        let response = await fetch(
            `${APIPrefix.get()}/api/mhp/properties/filingcabinet?type=${optionChoice.dataset.id}&noOfItemsPerPage=${NUMB_PER_PAGE}&sitecode=${siteCode}&plotcode=${plotCode}`
        );
        if (response.status == 200) {
            let data = await response.json();
            if (data.status == "failure") {
                loadMsg.innerText =  data.message;
                loadMsg.classList = 'error-title';
                errWr.appendChild(loadMsg);
            } else if (data.status === "401") {
                APIUtils.redirectUserToSigninPage();
            } else {
                return data;
            }
        }else{
            loadMsg.innerText = document.querySelector('.error-message').value;
            loadMsg.classList = 'error-title';
            errWr.appendChild(loadMsg);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    };

    let getMoWar =  async function() {
        let NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
        let siteCode = document.querySelector('#scode').value;
        let plotCode = document.querySelector('#pcode').value;
        let response = await fetch(
            `${APIPrefix.get()}/api/mhp/properties/filingcabinet?type=${movWar.dataset.id}&noOfItemsPerPage=${NUMB_PER_PAGE}&sitecode=${siteCode}&plotcode=${plotCode}`
        );
        if (response.status == 200) {
            let data = await response.json();
            if (data.status == "failure") {
                loadMsg.innerText =  data.message;
                loadMsg.classList = 'error-title';
                errWr.appendChild(loadMsg);
            } else if (data.status === "401") {
                APIUtils.redirectUserToSigninPage();
            } else {
                return data;
            }
        } else {
            loadMsg.innerText = document.querySelector('.error-message').value;
            loadMsg.classList = 'error-title';
            errWr.appendChild(loadMsg);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    };

    if (resExchange) {
        getResExachange()
            .then((data) => {
                createFilingCabinetData('ReservationToExchange', data);
            })
            .catch((e) => console.log(e));
    }
    if (exchangeComp) {
        getExchangeComp()
            .then((data) => {
                createFilingCabinetData('ExchangeToCompletion', data);
            })
            .catch((e) => console.log(e));
    }
    if (optionChoice) {
        getOptChoice()
            .then((data) => {
                createFilingCabinetData('OptionsAndChoices', data);
            })
            .catch((e) => console.log(e));
    }
    if (movWar) {
        getMoWar()
            .then((data) => {
                createFilingCabinetData('MovingInAndWarranty', data);
            })
            .catch((e) => console.log(e));
    }

    let createFilingCabinetData = function (type, data) {
        const HEADINGS = data.data.headings;
        const ITEMS = data.data.items;
        const CONFIGURATION = data.data.configuration;
        const TABLE_WRAPPER = document.querySelector('div[data-id="' + type + '"] .table-wrapper');
        const TABLE = document.createElement('table');
        TABLE.setAttribute('class', 'pagination');
        TABLE_WRAPPER.appendChild(TABLE);
        for (const field in data.data) {
            const THEAD = document.createElement('thead');
            const TABLE_ROW = document.createElement('tr');
            THEAD.appendChild(TABLE_ROW);
            const TBODY = document.createElement('tbody');
            if (field == 'headings') {
                for (const child in HEADINGS) {
                    const HEADER_CELL = document.createElement('th');
                    TABLE_ROW.appendChild(HEADER_CELL);
                    HEADER_CELL.innerText = HEADINGS[child];
                    TABLE.appendChild(THEAD);
                }
                const HEADER_CELL = document.createElement('th');
                HEADER_CELL.classList.add('disabled-sorting');
                TABLE_ROW.appendChild(HEADER_CELL);
                TABLE.appendChild(THEAD);
            } else if (field == 'items') {
                for (const child in ITEMS) {
                    const TABLE_ROW = document.createElement('tr');
                    let item = ITEMS[child].fields;
                    let btn = ITEMS[child].button;
                    for (const row in item) {
                        const TABLE_DATA = document.createElement('td');
                        TABLE_ROW.appendChild(TABLE_DATA);
                        TABLE_DATA.innerText = item[row];
                        TBODY.appendChild(TABLE_ROW);
                        TABLE.appendChild(TBODY);
                    }
                    if (item.type) {
                        const img = document.createElement('img');
                        img.src = item.type;
                        let first_cel = TABLE_ROW.insertCell(0);
                        first_cel.appendChild(img);
                    }
                    if (btn.url !== '') {
                        let link = document.createElement('a');
                        link.setAttribute('href', btn.url);
                        link.innerHTML = btn.name;
                        link.setAttribute('class', 'button button--primary');
                        link.setAttribute('target', '_blank');
                        link.setAttribute('title', btn.tooltip);
                        let NEW_CELL = TABLE_ROW.insertCell(-1);
                        NEW_CELL.appendChild(link);
                    } else {
                        let link = document.createElement('span');
                        link.innerHTML = btn.name;
                        let NEW_CELL = TABLE_ROW.insertCell(-1);
                        NEW_CELL.appendChild(link);
                    }
                }
            }
        }
        let dataTable = tableUtils.initPaginatedDataTable(TABLE_WRAPPER, CONFIGURATION, false, false);
        if (ITEMS !== undefined && ITEMS.length !== 0) {

            let paginationWrapper = TABLE_WRAPPER.querySelector('.dataTable-pagination');
            if (paginationWrapper && paginationWrapper.hasChildNodes()) {
                tableUtils.initPaginationControlStates(dataTable, paginationWrapper);
            }
        }

        let handleClick = (e) => {
            let datPag = document
                .querySelector(`div.tab-item-content[data-id*="${e.target.dataset.id}"]`)
                .querySelector('.dataTable-pagination');
            if (datPag) {
                if (datPag.innerHTML.length > 0) {
                    document
                        .querySelector(`div.tab-item-content[data-id*="${e.target.dataset.id}"]`)
                        .querySelector('.dataTable-pagination')
                        .firstElementChild.nextSibling.nextSibling.classList.add('active');
                    document
                        .querySelector(`div.tab-item-content[data-id*="${e.target.dataset.id}"]`)
                        .querySelector('.dataTable-pagination')
                        .firstElementChild.nextSibling.nextSibling.querySelector('a')
                        .click();
                }
            }
        };

        Array.from(FILING_CABINET_COMPONENT.querySelectorAll('.tablinks'), (btn) =>
            btn.addEventListener('click', handleClick, false)
        );

        if (ITEMS === undefined || ITEMS.length == 0) {
            let ERROR_MSG = document.createElement('span');
            ERROR_MSG.innerText = document.querySelector('.no-documents').value;
            ERROR_MSG.setAttribute('class', 'no-items');
            TABLE_WRAPPER.appendChild(ERROR_MSG);
            let dataTabWrap = TABLE_WRAPPER.querySelector('.dataTable-wrapper');
            dataTabWrap.style.display = 'none';
        }

    };
}